"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upsellActions = require("../../store/upsell/upsellActions");
var _upsellSelectors = require("../../store/upsell/upsellSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useInsuranceDetailsContent = () => {
  const selectedUpsellDisplayProduct = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectDisplayedUpsellProductDetails);
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const selectedUpsellProducts = (0, _useAppSelector.useAppSelector)(_upsellSelectors.selectSelectedUpsellProducts);
  const isSelected = product => {
    return selectedUpsellProducts[product.productType.toLowerCase()].includes(product.id);
  };
  const isDisabled = product => {
    return selectedUpsellProducts[product.productType.toLowerCase()].length;
  };
  const onClick = product => {
    if (isSelected(product)) {
      dispatch((0, _upsellActions.removeSelectedUpsellProduct)(product.id, product.category[0].id));
    } else {
      dispatch((0, _upsellActions.addSelectedUpsellProduct)(product.id, product.category[0].id));
    }
    dispatch((0, _upsellActions.removeDisplayedUpsellProductDetails)());
    dispatch((0, _upsellActions.goBackToRecommendation)());
  };
  return {
    product: selectedUpsellDisplayProduct,
    onClick,
    isSelected,
    isDisabled
  };
};
var _default = useInsuranceDetailsContent;
exports.default = _default;